// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"70":"70a394daeb8cf00d","705":"b63116970b17ff07","889":"efbf9a18349306f7"}[chunkId] + ".js";
};